import { Path } from "react-native-svg";

import { type IconProps, LineIcon } from "./LineIcon";

export function BookIcon(props: IconProps) {
  return (
    <LineIcon {...props}>
      <Path d="M4 5.5A1.5 1.5 0 0 1 5.5 4H11v15H5.5A1.5 1.5 0 0 0 4 20.5z" />
      <Path d="M20 5.5A1.5 1.5 0 0 0 18.5 4H13v15h5.5a1.5 1.5 0 0 1 1.5 1.5z" />
    </LineIcon>
  );
}
